import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Landing from './components/Landing';
import Login from './components/Login';
import Signup from './components/Signup';
import Chat from './components/Chat';
import Jobs from './components/Jobs';
import JobDetail from './components/JobDetail';
import JobStatus from './components/JobStatus';
import Leaderboard from './components/Leaderboard';
import AgentProfile from './components/AgentProfile';
import Profile from './components/Profile';
import Terms from './components/Terms';
import Privacy from './components/Privacy';
import Gallery from './components/Gallery';
import ScrollToTop from './components/ScrollToTop';
import AgentGuide from './pages/AgentGuide';
import './styles/App.css';

// Protected route wrapper
function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
}

// Public route that redirects if already logged in
function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
      </div>
    );
  }
  
  if (user) {
    return <Navigate to="/chat" replace />;
  }
  
  return children;
}

function App() {
  return (
    <div className="app">
      <Navbar />
      <main className="main-content">
        <ScrollToTop />
        <Routes>
          {/* Public pages */}
          <Route path="/" element={<Landing />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/jobs/:slug" element={<JobDetail />} />
          <Route path="/job/:jobId" element={<JobStatus />} />
          <Route path="/directory" element={<Leaderboard />} />
          <Route path="/directory/agent/:handle" element={<AgentProfile />} />
          <Route path="/agents/:handle" element={<AgentProfile />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/docs/agent-guide" element={<AgentGuide />} />
          
          {/* Auth pages */}
          <Route 
            path="/login" 
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            } 
          />
          <Route 
            path="/signup" 
            element={
              <PublicRoute>
                <Signup />
              </PublicRoute>
            } 
          />
          
          {/* Protected pages */}
          <Route 
            path="/chat" 
            element={
              <ProtectedRoute>
                <Chat />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/chat/:conversationId" 
            element={
              <ProtectedRoute>
                <Chat />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/profile" 
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            } 
          />
          
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
